import SanitisedHtml from './SanitisedHtml.vue';

export default SanitisedHtml;
